(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9386],{

/***/ 89157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ mergeOptionsWithPopperConfig; }
/* harmony export */ });
/* unused harmony exports toModifierMap, toModifierArray */
function toModifierMap(modifiers) {
  const result = {};
  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  }

  // eslint-disable-next-line no-unused-expressions
  modifiers == null ? void 0 : modifiers.forEach(m => {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map = {}) {
  if (Array.isArray(map)) return map;
  return Object.keys(map).map(k => {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig({
  enabled,
  enableEvents,
  placement,
  flip,
  offset,
  fixed,
  containerPadding,
  arrowElement,
  popperConfig = {}
}) {
  var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
  const modifiers = toModifierMap(popperConfig.modifiers);
  return Object.assign({}, popperConfig, {
    placement,
    enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(Object.assign({}, modifiers, {
      eventListeners: {
        enabled: enableEvents,
        options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
      },
      preventOverflow: Object.assign({}, modifiers.preventOverflow, {
        options: containerPadding ? Object.assign({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: Object.assign({
          offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: Object.assign({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: Object.assign({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}

/***/ }),

/***/ 83034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getRefTarget; }
/* harmony export */ });
/* harmony import */ var dom_helpers_contains__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8287);
/* harmony import */ var dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73201);
/* harmony import */ var dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61970);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63076);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62118);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(warning__WEBPACK_IMPORTED_MODULE_3__);






const noop = () => {};
function isLeftClickEvent(event) {
  return event.button === 0;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = ref => ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
  click: 'mousedown',
  mouseup: 'mousedown',
  pointerup: 'pointerdown'
};

/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useClickOutside(ref, onClickOutside = noop, {
  disabled,
  clickTrigger = 'click'
} = {}) {
  const preventMouseClickOutsideRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  const waitingForTrigger = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  const handleMouseCapture = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(e => {
    const currentTarget = getRefTarget(ref);
    warning__WEBPACK_IMPORTED_MODULE_3___default()(!!currentTarget, 'ClickOutside captured a close event but does not have a ref to compare it to. ' + 'useClickOutside(), should be passed a ref that resolves to a DOM node');
    preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0,dom_helpers_contains__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(currentTarget, e.target) || waitingForTrigger.current;
    waitingForTrigger.current = false;
  }, [ref]);
  const handleInitialMouse = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(e => {
    const currentTarget = getRefTarget(ref);
    if (currentTarget && (0,dom_helpers_contains__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(currentTarget, e.target)) {
      waitingForTrigger.current = true;
    } else {
      // When clicking on scrollbars within current target, click events are not triggered, so this ref
      // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
      // to close the overlay.
      waitingForTrigger.current = false;
    }
  });
  const handleMouse = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(e => {
    if (!preventMouseClickOutsideRef.current) {
      onClickOutside(e);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var _ownerWindow$event, _ownerWindow$parent;
    if (disabled || ref == null) return undefined;
    const doc = (0,dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(getRefTarget(ref));
    const ownerWindow = doc.defaultView || window;

    // Store the current event to avoid triggering handlers immediately
    // For things rendered in an iframe, the event might originate on the parent window
    // so we should fall back to that global event if the local one doesn't exist
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
    let removeInitialTriggerListener = null;
    if (InitialTriggerEvents[clickTrigger]) {
      removeInitialTriggerListener = (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
    }

    // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.
    const removeMouseCaptureListener = (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(doc, clickTrigger, handleMouseCapture, true);
    const removeMouseListener = (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(doc, clickTrigger, e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleMouse(e);
    });
    let mobileSafariHackListeners = [];
    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(el => (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(el, 'mousemove', noop));
    }
    return () => {
      removeInitialTriggerListener == null ? void 0 : removeInitialTriggerListener();
      removeMouseCaptureListener();
      removeMouseListener();
      mobileSafariHackListeners.forEach(remove => remove());
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleInitialMouse, handleMouse]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useClickOutside);

/***/ }),

/***/ 95953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_usePopper; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/dequal@2.0.3/node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@restart+hooks@0.5.1_react@18.2.0/node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(84390);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@restart+hooks@0.5.1_react@18.2.0/node_modules/@restart/hooks/esm/useSafeState.js



/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */

function useSafeState(state) {
  const isMounted = (0,useMounted/* default */.Z)();
  return [state[0], (0,react.useCallback)(nextState => {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}
/* harmony default export */ var esm_useSafeState = (useSafeState);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/arrow.js
var arrow = __webpack_require__(64142);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var computeStyles = __webpack_require__(62462);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var eventListeners = __webpack_require__(47687);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/flip.js + 3 modules
var flip = __webpack_require__(57982);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/hide.js
var hide = __webpack_require__(79088);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/offset.js
var offset = __webpack_require__(69044);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
var popperOffsets = __webpack_require__(77622);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js + 1 modules
var preventOverflow = __webpack_require__(6798);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/createPopper.js + 6 modules
var createPopper = __webpack_require__(92991);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@restart+ui@1.9.4_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@restart/ui/esm/popper.js











// For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment
const popper_createPopper = (0,createPopper/* popperGenerator */.kZ)({
  defaultModifiers: [hide/* default */.Z, popperOffsets/* default */.Z, computeStyles/* default */.Z, eventListeners/* default */.Z, offset/* default */.Z, flip/* default */.Z, preventOverflow/* default */.Z, arrow/* default */.Z]
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@restart+ui@1.9.4_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@restart/ui/esm/usePopper.js
const _excluded = ["enabled", "placement", "strategy", "modifiers"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }




const disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false,
  phase: 'afterWrite',
  fn: () => undefined
};

// until docjs supports type exports...

const ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: ({
    state
  }) => () => {
    const {
      reference,
      popper
    } = state.elements;
    if ('removeAttribute' in reference) {
      const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(id => id.trim() !== popper.id);
      if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
    }
  },
  fn: ({
    state
  }) => {
    var _popper$getAttribute;
    const {
      popper,
      reference
    } = state.elements;
    const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      const ids = reference.getAttribute('aria-describedby');
      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }
      reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
    }
  }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */
function usePopper(referenceElement, popperElement, _ref = {}) {
  let {
      enabled = true,
      placement = 'bottom',
      strategy = 'absolute',
      modifiers = EMPTY_MODIFIERS
    } = _ref,
    config = _objectWithoutPropertiesLoose(_ref, _excluded);
  const prevModifiers = (0,react.useRef)(modifiers);
  const popperInstanceRef = (0,react.useRef)();
  const update = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu;
    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  const forceUpdate = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu2;
    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);
  const [popperState, setState] = esm_useSafeState((0,react.useState)({
    placement,
    update,
    forceUpdate,
    attributes: {},
    styles: {
      popper: {},
      arrow: {}
    }
  }));
  const updateModifier = (0,react.useMemo)(() => ({
    name: 'updateStateModifier',
    enabled: true,
    phase: 'write',
    requires: ['computeStyles'],
    fn: ({
      state
    }) => {
      const styles = {};
      const attributes = {};
      Object.keys(state.elements).forEach(element => {
        styles[element] = state.styles[element];
        attributes[element] = state.attributes[element];
      });
      setState({
        state,
        styles,
        attributes,
        update,
        forceUpdate,
        placement: state.placement
      });
    }
  }), [update, forceUpdate, setState]);
  const nextModifiers = (0,react.useMemo)(() => {
    if (!dequal(prevModifiers.current, modifiers)) {
      prevModifiers.current = modifiers;
    }
    return prevModifiers.current;
  }, [modifiers]);
  (0,react.useEffect)(() => {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement,
      strategy,
      modifiers: [...nextModifiers, updateModifier, disabledApplyStylesModifier]
    });
  }, [strategy, placement, updateModifier, enabled, nextModifiers]);
  (0,react.useEffect)(() => {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }
    popperInstanceRef.current = popper_createPopper(referenceElement, popperElement, Object.assign({}, config, {
      placement,
      strategy,
      modifiers: [...nextModifiers, ariaDescribedByModifier, updateModifier]
    }));
    return () => {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(s => Object.assign({}, s, {
          attributes: {},
          styles: {
            popper: {}
          }
        }));
      }
    };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}
/* harmony default export */ var esm_usePopper = (usePopper);

/***/ }),

/***/ 3106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PrintConfigContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


var PrintConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isPrint: false,
    images: {
        lazyloadEnabled: true
    }
});
var PrintConfigProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrintConfigContext.Provider, {
        value: {
            isPrint: true,
            images: {
                lazyloadEnabled: false
            }
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrintConfigProvider);


/***/ }),

/***/ 42500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CloudinaryImage_CloudinaryImage; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.module.scss
var CloudinaryImage_module = __webpack_require__(47464);
var CloudinaryImage_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryImage_module);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(49077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+react@1.5.0_@cloudinary+url-gen@1.8.6_@types+react@18.0.20_react@18.2.0/node_modules/@cloudinary/react/index.js
var react = __webpack_require__(90330);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 38 modules
var resize = __webpack_require__(66469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+url-gen@1.8.6/node_modules/@cloudinary/url-gen/assets/CloudinaryVideo.js + 1 modules
var CloudinaryVideo = __webpack_require__(54074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-device-pixel-ratio@1.1.2_react@18.2.0/node_modules/use-device-pixel-ratio/dist/index.module.js
var index_module = __webpack_require__(16867);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/delivery.js + 5 modules
var delivery = __webpack_require__(94134);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var node_modules_react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/app/providers/PrintConfigProvider.tsx
var PrintConfigProvider = __webpack_require__(3106);
;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.tsx












var CloudinaryImage = function(param) {
    var image = param.image, tmp = param.lazyload, lazyloadOption = tmp === void 0 ? true : tmp, tmp1 = param.responsive, responsiveOption = tmp1 === void 0 ? true : tmp1, tmp2 = param.placeholder, placeholderOption = tmp2 === void 0 ? false : tmp2, width = param.width, height = param.height, _sizeAttributes = param.sizeAttributes, sizeAttributes = _sizeAttributes === void 0 ? false : _sizeAttributes, tmp3 = param.dpr, dprOption = tmp3 === void 0 ? true : tmp3, _cropType = param.cropType, cropType = _cropType === void 0 ? "fill" : _cropType, aspectRatio = param.aspectRatio, titleDefault = param.titleDefault, altDefault = param.altDefault, _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _placeholderClassName = param.placeholderClassName, placeholderClassName = _placeholderClassName === void 0 ? "" : _placeholderClassName, cld = param.cld, trackingStringClick = param.trackingStringClick, trackingStringDblClick = param.trackingStringDblClick;
    var deviceDpr = (0,index_module/* useDevicePixelRatio */.j)();
    var printConfig = (0,node_modules_react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    lazyloadOption = printConfig.images.lazyloadEnabled === false ? false : lazyloadOption;
    if (!(image === null || image === void 0 ? void 0 : image.publicId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((CloudinaryImage_module_default()).placeholder, " ").concat(placeholderClassName)
        });
    }
    if (!cld) {
        cld = cloudinaryUrlGenerator/* default */.Z;
    }
    var mediaFile = image.resourceType === "video" ? cld.video(image.publicId) : cld.image(image.publicId);
    var options = {};
    if (aspectRatio) {
        options.aspect_ratio = aspectRatio;
    }
    if (image.resourceType !== "video") {
        mediaFile.format("auto").quality("auto");
    } else {
        mediaFile.format("auto").quality(70);
    }
    if (dprOption && image.resourceType !== "video") {
        var imageDpr = Number.isInteger(dprOption) ? dprOption : deviceDpr;
        mediaFile.delivery((0,delivery/* dpr */.uN)(imageDpr + ".0"));
    } else {
    // omit dpr for videos
    //mediaFile.delivery(dpr('1.0'))
    }
    var cropSettings;
    switch(cropType){
        case "fill":
            cropSettings = (0,resize/* fill */.hl)();
            break;
        case "scale":
            cropSettings = (0,resize/* scale */.bA)();
            break;
    }
    if (!responsiveOption) {
        if (width) {
            cropSettings.width(width);
        }
        if (height) {
            cropSettings.height(height);
        }
    }
    if (aspectRatio) {
        cropSettings.aspectRatio(aspectRatio);
    }
    if (cropType === "fill" && (aspectRatio || width || height)) {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            // Videos cannot handle gravity('auto') on mobile
            // @ts-ignore
            cropSettings.gravity("center");
        } else {
            // @ts-ignore
            cropSettings.gravity("auto");
        }
    }
    mediaFile.resize(cropSettings);
    // see: https://cloudinary.com/documentation/react_image_transformations#plugins
    var plugins = [];
    // placeholder
    // Note: Not using recommended plugin order, as this loads the display image before placeholder image | see: https://cloudinary.com/documentation/react_image_transformations#plugin_order
    if (placeholderOption || lazyloadOption === "placeholder") {
        plugins.push((0,react/* placeholder */.W$)({
            mode: "blur"
        })) // see: https://cloudinary.com/documentation/react_image_transformations#image_placeholders
        ;
    }
    // lazyload
    if (lazyloadOption) {
        plugins.push((0,react/* lazyload */.mA)());
    }
    // responsive breakpoints
    if (responsiveOption) {
        plugins.push((0,react/* responsive */.jW)({
            steps: 200
        }));
    }
    var getSizeAttributes = function() {
        if (sizeAttributes) {
            // custom sizes
            if (width && height) {
                return {
                    width: width,
                    height: height
                };
            }
            // dynamic sizes by aspect ratio
            if (aspectRatio) {
                if (width) {
                    return {
                        width: width,
                        height: width / aspectRatio
                    };
                }
                if (height) {
                    return {
                        width: height * aspectRatio,
                        height: height
                    };
                }
            }
            // intrinsic sizes
            return {
                width: image.width,
                height: image.height
            };
        }
        return {};
    };
    var getTrackingAttributes = function() {
        var trackingAttributes = {};
        // if "trackingStringClick" is set, build "data-tr-click={trackingStringClick}"
        if (trackingStringClick) {
            trackingAttributes["data-tr-click"] = trackingStringClick;
        }
        // if "trackingStringDblClick" is set, build "data-tr-click={trackingStringDblClick}"
        if (trackingStringDblClick) {
            trackingAttributes["data-tr-dblclick"] = trackingStringDblClick;
        }
        return trackingAttributes;
    };
    return function() {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            var posterImage = mediaFile.addTransformation("so_0").toURL();
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedVideo */.xl, {
                cldVid: mediaFile,
                poster: posterImage,
                plugins: plugins,
                autoPlay: true,
                playsInline: true,
                loop: true,
                muted: true
            });
        }
        var _title, ref, _description, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedImage */.pw, (0,_object_spread/* default */.Z)({
            className: className,
            cldImg: mediaFile,
            plugins: plugins,
            title: (ref = (_title = image.title) !== null && _title !== void 0 ? _title : titleDefault) !== null && ref !== void 0 ? ref : "",
            alt: (ref1 = (_description = image.description) !== null && _description !== void 0 ? _description : altDefault) !== null && ref1 !== void 0 ? ref1 : "",
            loading: lazyloadOption === true ? "lazy" : "auto",
            style: style !== null && style !== void 0 ? style : {}
        }, getSizeAttributes(), getTrackingAttributes()));
    }();
};
/* harmony default export */ var CloudinaryImage_CloudinaryImage = (CloudinaryImage);

;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/index.ts



/***/ }),

/***/ 5183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _components_elements_media_CloudinaryImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42500);
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73974);





var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_2__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "difp9jq5j"
    },
    url: {
        analytics: false
    }
});
var ThemeImage = function(props) {
    var cropType = props.cropType;
    if (!props.cropType) {
        cropType = "scale";
    }
    var responsive = props.responsive !== undefined ? props.responsive : false;
    var theme = props.theme ? props.theme : "rex";
    var image = props.image ? props.image : {
        publicId: "themes/".concat(theme, "/").concat(props.src),
        title: props.title,
        description: props.alt
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_media_CloudinaryImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        image: image,
        responsive: responsive,
        cropType: cropType,
        dpr: props.dpr !== undefined ? props.dpr : false,
        cld: cloudinaryUrlGenerator,
        style: props.style ? props.style : {},
        sizeAttributes: true
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ThemeImage);


/***/ }),

/***/ 23651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ header_Header; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/template/header/Header.module.scss
var Header_module = __webpack_require__(35991);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Navbar.js + 11 modules
var Navbar = __webpack_require__(32813);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Nav.js + 1 modules
var Nav = __webpack_require__(55628);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js
var classnames = __webpack_require__(51865);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(48950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Dropdown.js + 4 modules
var Dropdown = __webpack_require__(11076);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/NavLink.js
var NavLink = __webpack_require__(16232);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/NavDropdown.js







const NavDropdown = /*#__PURE__*/react.forwardRef(({
  id,
  title,
  children,
  bsPrefix,
  className,
  rootCloseEvent,
  menuRole,
  disabled,
  active,
  renderMenuOnMount,
  menuVariant,
  ...props
}, ref) => {
  /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */
  const navItemPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(undefined, 'nav-item');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
    ref: ref,
    ...props,
    className: classnames_default()(className, navItemPrefix),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
      id: id,
      eventKey: null,
      active: active,
      disabled: disabled,
      childBsPrefix: bsPrefix,
      as: NavLink/* default */.Z,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Menu */.Z.Menu, {
      role: menuRole,
      renderOnMount: renderMenuOnMount,
      rootCloseEvent: rootCloseEvent,
      variant: menuVariant,
      children: children
    })]
  });
});
NavDropdown.displayName = 'NavDropdown';
/* harmony default export */ var esm_NavDropdown = (Object.assign(NavDropdown, {
  Item: Dropdown/* default.Item */.Z.Item,
  ItemText: Dropdown/* default.ItemText */.Z.ItemText,
  Divider: Dropdown/* default.Divider */.Z.Divider,
  Header: Dropdown/* default.Header */.Z.Header
}));
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/link.js
var next_link = __webpack_require__(64127);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/template/navigations/MainNavigation/ContactModal/ContactModal.module.scss
var ContactModal_module = __webpack_require__(94948);
var ContactModal_module_default = /*#__PURE__*/__webpack_require__.n(ContactModal_module);
// EXTERNAL MODULE: ./src/components/elements/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(57579);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(73153);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(10833);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ./src/components/elements/media/ThemeImage/ThemeImage.tsx
var ThemeImage = __webpack_require__(5183);
;// CONCATENATED MODULE: ./src/components/template/navigations/MainNavigation/ContactModal/ContactModal.tsx







var ContactModal = function(param) {
    var contactBlockSettings = param.contactBlockSettings;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var slogan = contactBlockSettings.slogan, text = contactBlockSettings.text, phonePrefix = contactBlockSettings.phonePrefix, phone = contactBlockSettings.phone, phone2Prefix = contactBlockSettings.phone2Prefix, phone2 = contactBlockSettings.phone2, openingHours1 = contactBlockSettings.openingHours1, openingHours2 = contactBlockSettings.openingHours2, email = contactBlockSettings.email;
    var phoneLink = !phone ? phone : "tel:" + phone.replace("(0)", "").split(" ").join("");
    var phone2Link = !phone2 ? phone2 : "tel:" + phone2.replace("(0)", "").split(" ").join("");
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn-unstyled icon-link",
                "aria-label": "Kontakt",
                onClick: handleShow,
                "data-tr-click": "header:contact_modal:open",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: "phone-call",
                    className: "icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: handleClose,
                className: (ContactModal_module_default()).modal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        className: (ContactModal_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            className: (ContactModal_module_default()).title,
                            children: slogan
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                        className: (ContactModal_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    className: "mb-4",
                                    children: text
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: (ContactModal_module_default()).contactBlock,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: "auto",
                                                    className: "".concat((ContactModal_module_default()).icon, " align-content-center"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                                                        src: "/images/mandatory/icons/contact/phone.png",
                                                        alt: "icon",
                                                        width: 60,
                                                        height: 60
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((ContactModal_module_default()).link, " mb-1"),
                                                                children: [
                                                                    phonePrefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            phonePrefix,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: phoneLink,
                                                                        "data-tr-click": "contact_modal:contact_phone:click",
                                                                        children: phone
                                                                    })
                                                                ]
                                                            }),
                                                            phone2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((ContactModal_module_default()).link, " mb-1"),
                                                                children: [
                                                                    phone2Prefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            phone2Prefix,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: phone2Link,
                                                                        "data-tr-click": "contact_modal:contact_phone:click",
                                                                        children: phone2
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (ContactModal_module_default()).openingHours,
                                                                children: [
                                                                    openingHours1,
                                                                    openingHours2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            openingHours2
                                                                        ]
                                                                    }) : ""
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: "".concat((ContactModal_module_default()).contactBlock, " mb-0"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: "auto",
                                                    className: (ContactModal_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                                                        src: "images/mandatory/icons/contact/mail.png",
                                                        alt: "icon",
                                                        width: 60,
                                                        height: 60
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ContactModal_module_default()).link,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:" + email,
                                                            "data-tr-click": "contact_modal:contact_email:click",
                                                            children: email
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                        className: (ContactModal_module_default()).footer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "light",
                            onClick: handleClose,
                            className: (ContactModal_module_default()).button,
                            children: t("button.close")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactModal_ContactModal = (ContactModal);

;// CONCATENATED MODULE: ./src/components/template/navigations/MainNavigation/ContactModal/index.tsx


;// CONCATENATED MODULE: ./src/components/template/navigations/MainNavigation/MainNavigation.tsx




var MainNavigation = function(param) {
    var categories = param.categories, contactBlockSettings = param.contactBlockSettings;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Toggle */.Z.Toggle, {
                "aria-controls": "main-nav"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default.Collapse */.Z.Collapse, {
                id: "main-nav",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                        className: "me-auto",
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                        className: "main-nav",
                        children: [
                            categories && categories.map(function(category, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_NavDropdown, {
                                    title: category.name,
                                    id: "collapsible-nav-dropdown-".concat(index),
                                    children: category.pages// filter out pages that are not to be displayed (OFFLINE/HIDDEN)
                                    .filter(function(page) {
                                        return page.onlineStatus === "ONLINE";
                                    }).map(function(page, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(category.seoSettings.urlSlug, "/").concat(page.seoSettings.urlSlug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_NavDropdown.Item, {
                                                "data-tr-click": "header:main_navigation_link:click",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: page.name
                                                })
                                            })
                                        }, index);
                                    })
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon-links",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactModal_ContactModal, {
                                    contactBlockSettings: contactBlockSettings
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MainNavigation_MainNavigation = (MainNavigation);

;// CONCATENATED MODULE: ./src/components/template/navigations/MainNavigation/index.tsx

/* harmony default export */ var navigations_MainNavigation = (MainNavigation_MainNavigation);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ./src/themes/rex/components/template/header/HeaderLogo/HeaderLogo.module.scss
var HeaderLogo_module = __webpack_require__(88186);
var HeaderLogo_module_default = /*#__PURE__*/__webpack_require__.n(HeaderLogo_module);
;// CONCATENATED MODULE: ./src/themes/rex/components/template/header/HeaderLogo/HeaderLogo.tsx




var HeaderLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
        src: "images/mandatory/logo.png",
        height: 96,
        width: 264,
        alt: "logo",
        lazyload: false,
        dpr: true,
        className: (HeaderLogo_module_default()).root
    });
};
/* harmony default export */ var HeaderLogo_HeaderLogo = (HeaderLogo);

;// CONCATENATED MODULE: ./src/themes/rex/components/template/header/HeaderLogo/index.tsx


// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(11296);
// EXTERNAL MODULE: ./src/components/elements/BreakingNewsAlert/BreakingNewsAlert.module.scss
var BreakingNewsAlert_module = __webpack_require__(25789);
var BreakingNewsAlert_module_default = /*#__PURE__*/__webpack_require__.n(BreakingNewsAlert_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(8665);
;// CONCATENATED MODULE: ./src/components/elements/BreakingNewsAlert/BreakingNewsAlert.tsx





var BreakingNewsAlert = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, onHeightChange = param.onHeightChange;
    var ref = (0,react.useRef)(null);
    // report the height so the navbar can be placed below the alert
    (0,react.useEffect)(function() {
        if (!ref.current || !onHeightChange) return;
        var observer = new ResizeObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            return onHeightChange(entry.target.getBoundingClientRect().height);
        });
        observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        onHeightChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            fluid: true,
            ref: ref,
            className: "".concat((BreakingNewsAlert_module_default()).root, " ").concat(className ? (BreakingNewsAlert_module_default())[className] : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                variant: "danger",
                className: (BreakingNewsAlert_module_default()).alert,
                children: "Aktuell k\xf6nnen aus technischen Gr\xfcnden keine Online-Buchungen get\xe4tigt werden. Gerne nehmen wir Ihre Buchung telefonisch oder per E-Mail entgegen."
            })
        })
    });
};
/* harmony default export */ var BreakingNewsAlert_BreakingNewsAlert = (BreakingNewsAlert);

;// CONCATENATED MODULE: ./src/components/elements/BreakingNewsAlert/index.tsx


// EXTERNAL MODULE: ./src/app/providers/AppConfigProvider.tsx
var AppConfigProvider = __webpack_require__(73496);
;// CONCATENATED MODULE: ./src/components/template/header/Header.tsx










// eslint-disable-next-line react/display-name
var MemoMainNavigation = /*#__PURE__*/ react.memo(function(Props) {
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navigations_MainNavigation, (0,_object_spread/* default */.Z)({}, Props));
});
// eslint-disable-next-line react/display-name
var MemoHeaderLog = /*#__PURE__*/ react.memo(function() {
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo_HeaderLogo, {});
});
var Header = function(param) {
    var cms = param.cms;
    // navbar color
    var colorTriggerDistance = 100;
    var ref = (0,react.useState)(false), colorChange = ref[0], setColorChange = ref[1];
    var changeNavbarColor = function() {
        if (window.scrollY >= colorTriggerDistance) {
            setColorChange(true);
        } else {
            setColorChange(false);
        }
    };
    if (true) {
        window.addEventListener("scroll", changeNavbarColor, {
            passive: true
        });
    }
    // navbar visibility
    var visibilityTriggerDistance = 500;
    var initialY =  true ? window.scrollY : 0;
    var ref1 = (0,react.useState)(true), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)(initialY), y = ref2[0], setY = ref2[1];
    var handleNavbarVisibility = (0,react.useCallback)(function(e) {
        var _$window = e.currentTarget;
        if (y > _$window.scrollY) {
            setVisible(true);
        } else if (y < _$window.scrollY) {
            if (_$window.scrollY > visibilityTriggerDistance) {
                setVisible(false);
            }
        }
        setY(_$window.scrollY);
    }, [
        y
    ]);
    (0,react.useEffect)(function() {
        setY(window.scrollY);
        window.addEventListener("scroll", handleNavbarVisibility, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleNavbarVisibility);
        };
    }, [
        handleNavbarVisibility
    ]);
    // breaking news alert above the navbar, pkag only shows the notice in the booking wizard
    var appConfig = (0,react.useContext)(AppConfigProvider/* AppConfigContext */.J);
    var showBreakingNews = appConfig.maintenance.onlineBookingUnavailable && "rex" !== "pkag";
    var ref3 = (0,react.useState)(0), breakingNewsHeight = ref3[0], setBreakingNewsHeight = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                showBreakingNews && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakingNewsAlert_BreakingNewsAlert, {
                    className: !visible ? "hidden" : "",
                    onHeightChange: setBreakingNewsHeight
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                    collapseOnSelect: true,
                    expand: "xl",
                    fixed: "top",
                    style: showBreakingNews && visible ? {
                        top: breakingNewsHeight
                    } : undefined,
                    className: "".concat((Header_module_default()).navbar, " ").concat(colorChange ? (Header_module_default()).bgWhite : "", " ").concat(!visible ? (Header_module_default()).hidden : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        fluid: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                passHref: true,
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Brand */.Z.Brand, {
                                    "data-tr-click": "header:logo:click",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoHeaderLog, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoMainNavigation, {
                                categories: cms.categories,
                                contactBlockSettings: cms.config.contactBlockSettings
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var header_Header = (Header);

;// CONCATENATED MODULE: ./src/components/template/header/index.tsx



/***/ }),

/***/ 49077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73974);

var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "skag"
    },
    url: {
        analytics: false
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (cloudinaryUrlGenerator);


/***/ }),

/***/ 25789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"BreakingNewsAlert_root__vhYSw","hidden":"BreakingNewsAlert_hidden__Pe46j","alert":"BreakingNewsAlert_alert__7hlKe"};

/***/ }),

/***/ 47464:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CloudinaryImage_placeholder__kWdxK"};

/***/ }),

/***/ 35991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__LmPAV","bgWhite":"Header_bgWhite__GfykR","hidden":"Header_hidden__pM4KD"};

/***/ }),

/***/ 94948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"ContactModal_modal__zYDNs","header":"ContactModal_header___i3ps","title":"ContactModal_title__ZVpHk","body":"ContactModal_body__qvxu5","contactBlock":"ContactModal_contactBlock___Tuc_","icon":"ContactModal_icon__zpYUM","link":"ContactModal_link__gSY2Z","openingHours":"ContactModal_openingHours__Y8Ttt","footer":"ContactModal_footer__hSl8X","button":"ContactModal_button__sDJok"};

/***/ }),

/***/ 88186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderLogo_root__W4ce9"};

/***/ }),

/***/ 38332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Collapse; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js
var classnames = __webpack_require__(51865);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(59969);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(57050);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(89943);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(18444);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(54101);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);

/***/ }),

/***/ 83506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'InputGroupContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 62118:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ })

}]);